import { createFileRoute, DefaultGlobalNotFound, notFound } from '@tanstack/react-router';

export const Route = createFileRoute('/www/$')({
	loader: () => {
		throw notFound();
	},
	notFoundComponent: RouteComponent,
	component: RouteComponent,
});

function RouteComponent() {
	return <DefaultGlobalNotFound />;
}
